import { SVGProps, Ref, forwardRef } from 'react';

export const SendWebFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M10.696 8.266 4.108 21.628c-2.36 4.785-3.54 7.178-2.234 8.444 1.305 1.265 4.038.378 9.504-1.396l1.02-.331L16 12.504l3.6 15.84 1.023.332c5.466 1.774 8.199 2.66 9.504 1.396 1.305-1.266.125-3.659-2.234-8.444L21.304 8.266C19.025 3.644 17.886 1.333 16 1.333s-3.026 2.311-5.304 6.933"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendWebFilledSize32Glyph.displayName = 'SendWebFilledSize32Glyph';
